
export const GET_USER_DOCUMENT_DATA = 'GET_USER_DOCUMENT_DATA'
export const CLEAR_USER_DOCUMENT_DATA = 'CLEAR_USER_DOCUMENT_DATA'


export const GET_REQUIRED_DOCUMENT_DATA = 'GET_REQUIRED_DOCUMENT_DATA'
export const CLEAR_REQUIRED_DOCUMENT_DATA = 'CLEAR_REQUIRED_DOCUMENT_DATA'

export const GET_RYFT_ONBOARDING_STEP = 'GET_RYFT_ONBOARDING_STEP'
export const CLEAR_RYFT_ONBOARDING_STEP = 'CLEAR_RYFT_ONBOARDING_STEP'

export const GET_RYFT_ONBOARDING_FIRST_SCREEN = 'GET_RYFT_ONBOARDING_FIRST_SCREEN'
export const CLEAR_RYFT_ONBOARDING_FIRST_SCREEN = 'CLEAR_RYFT_ONBOARDING_FIRST_SCREEN'

export const GET_RYFT_VERIFICATION_STATUS = 'GET_RYFT_VERIFICATION_STATUS'
export const CLEAR_RYFT_VERIFICATION_STATUS = 'CLEAR_RYFT_VERIFICATION_STATUS'